module.exports = __webpack_public_path__ + "static/Philippe_Bedard_headshot_lores-342929a235e8d9c92a99693d7eb81f27.png";